import { Typography, Checkbox, Tooltip, Box, CircularProgress, Chip } from "@mui/material";
import moment from "moment-timezone";

const InvoiceList = ({
  invoices,
  setInvoice,
  status,
  selected,
  setSelected,
  onLoadMore,
  hasMore = false,
  loadingMore = false,
  height = "70vh",
}) => {
  const formatDate = (d, format = true) => {
    const userTimezone = moment.tz.guess();
    const formattedDate = moment.tz(d, userTimezone);
    const now = moment.tz(userTimezone);

    let isOverdue = false;
    if (format) {
      isOverdue = formattedDate.isBefore(now, "day");
    }

    return (
      <Typography align="center" color={isOverdue ? "error" : "inherit"}>
        {formattedDate.format("YYYY-MM-DD")}
      </Typography>
    );
  };

  return (
    <Box
      onScroll={(e) => {
        if (!onLoadMore || !hasMore || loadingMore) return;
        const container = e.currentTarget;

        const distanceFromBottom =
          container.scrollHeight -
          container.scrollTop -
          container.clientHeight;

        // Trigger when within 50px of bottom
        if (distanceFromBottom < 50) {
          onLoadMore();
        }
      }}
      sx={{
        height,
        overflowY: "auto",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ textAlign: "left" }}>
              <Checkbox
                checked={
                  selected.length === invoices.length && invoices.length > 0
                }
                indeterminate={
                  selected.length > 0 && selected.length < invoices.length
                }
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelected(invoices.map((invoice) => invoice._id));
                  } else {
                    setSelected([]);
                  }
                }}
              />
            </th>
            <th>Org</th>
            <th>Event</th>
            <th>Event Date</th>
            <th>Status</th>
            <th>Amount</th>
            <th>Due Date</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((invoice) => (
            <tr
              key={invoice?._id}
              style={{ cursor: "pointer", borderBottom: "0.5px solid #cecaca" }}
            >
              <td>
                <Checkbox
                  checked={selected.includes(invoice?._id)}
                  onChange={(e) => {
                    e.stopPropagation();
                    setSelected((prev) =>
                      prev.includes(invoice?._id)
                        ? prev.filter((id) => id !== invoice?._id)
                        : [...prev, invoice?._id],
                    );
                  }}
                />
              </td>
              <td
                style={{ textAlign: "center" }}
                onClick={() => setInvoice(invoice)}
              >
                {invoice?.org?.name}
              </td>
              <td onClick={() => setInvoice(invoice)}>
                <Tooltip title={invoice?.event?.name} arrow>
                  <Typography variant="subtitle2" align="center">
                    {invoice?.event?.name?.length > 20
                      ? invoice?.event?.name.slice(0, 20) + "..."
                      : invoice?.event?.name}
                  </Typography>
                </Tooltip>
              </td>
              <td
                style={{ textAlign: "center" }}
                onClick={() => setInvoice(invoice)}
              >
                {formatDate(invoice?.event?.date, false)}
              </td>
              <td
                style={{ textAlign: "center" }}
                onClick={() => setInvoice(invoice)}
              >
                {invoice?.status}
                {invoice?.autoPayScheduledAt && invoice?.status === "open" && (
                  <Tooltip
                    title={`Auto-pay scheduled for ${new Date(invoice.autoPayScheduledAt).toLocaleString()}`}
                    arrow
                  >
                    <Chip
                      label="Auto-pay"
                      size="small"
                      color="info"
                      sx={{ display: "block", mx: "auto", mt: 0.5, mb: 0.5, fontSize: "0.65rem", height: 18, width: 60 }}
                    />
                  </Tooltip>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                ${status === "paid" ? invoice?.amountPaid : invoice?.amountDue}
              </td>
              <td
                style={{ textAlign: "center" }}
                onClick={() => setInvoice(invoice)}
              >
                {formatDate(invoice?.dueDate)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {loadingMore && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
          <CircularProgress size={24} />
        </Box>
      )}
    </Box>
  );
};

export default InvoiceList;
